import React, { FC, useEffect, useState } from 'react';
import { ReactComponent as UpdateSurgeIcon } from 'assets/icons/update-surge-modal-icon.svg';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import './styles.scss';
import { toast } from 'react-toastify';
import { OrderType } from 'models/order.model';
import { InstantTabPayload } from 'components/logistics/surge/surge-tabs/types';
import { apiService } from 'utils/api';
import SurgeApplyNowSection from 'components/logistics/surge/surge-tabs/surge-apply-now';

interface UpdateSurgeModalProps {
  show: boolean;
  order: OrderType;
  onClose: () => void;
}

interface UpdateSurgeFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const baseUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;

const UpdateSurgeFooter: FC<UpdateSurgeFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const getInitSurge = (order: OrderType) => {
  const returnVal = order.surge
    ? {
        logistics_surge: order.surge.logistics_surge,
        logistics_surge_type: order.surge.logistics_surge_type,
        id: ''
      }
    : ({} as InstantTabPayload);

  return returnVal as InstantTabPayload;
};

const UpdateSurgeModal: FC<UpdateSurgeModalProps> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);
  const [surge, setSurge] = useState(getInitSurge(order));

  const updateOrderSurge = async () => {
    setLoading(true);
    try {
      const data = {
        ...surge,
        logistics_surge: Number(surge.logistics_surge),
        order_id: order?.id
      };

      await apiService.post('marketing/surge', { data, baseUrl });
      toast(<ToastMessage type='success' message='Surge updated successfully' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { logistics_surge = '', logistics_surge_type = '' } = order.surge ?? {};
    setSurge({ logistics_surge, logistics_surge_type });
  }, []);

  return (
    <BaseModal
      isOpen={show}
      title={`Update Order #${order?.order_code?.toUpperCase() ?? ''} Surge`}
      description='Update surge for this order?'
      titleIcon={<UpdateSurgeIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <UpdateSurgeFooter loading={loading} onCancel={onClose} onConfirm={updateOrderSurge} />
      }>
      <SurgeApplyNowSection value={surge} setValue={setSurge} />
    </BaseModal>
  );
};

export default UpdateSurgeModal;
